









































































import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import ChoiceFactorInput from "@/components/choice-input/ChoiceFactorInput.vue";
import DescriptionEditor from "@/components/common/DescriptionEditor.vue";
import { ValueTypeDefinition } from "@/api/model/FactorResource";

@Component({
    components: {ChoiceFactorInput, DescriptionEditor}
})
export default class ChoiceFactorInputMenu extends Vue {

    @Model('updated:value')
    value!: any;

    @Prop()
    choiceId!: string;

    @Prop()
    valueTypeDefinition!: ValueTypeDefinition

    get valueType() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valueType;
    }

    get valueSubType() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valueSubType;
    }

    get valuePrefix() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valuePrefix;
    }

    get valueSuffix() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valueSuffix;
    }

    get categoricalValues() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.categoricalValues;
    }


    @Prop()
    innerClass: string;

    @Prop({default: false})
    disabled: Boolean;

    @Prop()
    show!: boolean;

    private internalValue = {val: null};
    private open = false;

    mounted() {
        this.internalValue = {val: this.value};
        if (this.show) {
            setTimeout(() => this.open = this.show, 200)
        }
    }

    @Watch('open')
    onOpenChange(newVal: boolean, oldVal: boolean) {
        if (!newVal && oldVal) {
            this.closedMenu();
        } else if (newVal) {
            this.internalValue = {val: this.value};
            this.$emit('open')
        }
    }

    @Watch('show')
    onShowChange(newVal: boolean) {
        this.open = newVal;
    }

    @Emit('closed')
    private closedMenu() {
        return this.internalValue.val;
    }

    @Emit('updated:value')
    @Emit('closed')
    @Emit('save')
    private save() {
        this.open = false;
        return this.internalValue.val;
    }

    @Emit('cancel')
    private cancel() {
        this.internalValue = {val: this.value};
        this.open = false;
    }


}
